import type { ReactNode } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';

import CardBody from 'hb-react/frontoffice/apps/Mentoring/components/SharedCard/CardBody';
import type { SharedCardProfile } from 'hb-react/frontoffice/apps/Mentoring/types';
import type {
  MenteesCustomizableAttributes,
  MentorsCustomizableAttributes,
} from 'hb-react/frontoffice/apps/MyMentoring/utils/types';

interface CardWrapperProps {
  profile: SharedCardProfile;
  customAttributes:
    | MenteesCustomizableAttributes
    | MentorsCustomizableAttributes;
  children: ReactNode;
  isSkillsDisplayed: boolean;
  isLocationDisplayed: boolean;
}

const CardWrapper = ({
  isSkillsDisplayed,
  customAttributes,
  isLocationDisplayed,
  profile,
  children,
}: CardWrapperProps) => (
  <Card height="100%" pb={5} pl={4} pr={4} pt={4}>
    <Box flexDirection="column" height="100%">
      <CardBody
        profile={profile}
        customAttributes={customAttributes}
        isSkillsDisplayed={isSkillsDisplayed}
        isLocationDisplayed={isLocationDisplayed}
      />
      {children}
    </Box>
  </Card>
);

export default CardWrapper;
